import { Fragment, memo } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SquareStackIcon, TrashIcon } from '@/icons';
import { useQuizList } from '../useQuizList';
import { EditableMatch } from './Match/EditableMatch';
import { useMatchPairs } from './Match/useMatchPairs';
import { EditableHint } from './EditableHint';
import { EditTools } from './EditTools';
import { useQuizControl } from './QuizControlProvider';
export const MatchBody = memo(({
  leftSlot
}: {
  leftSlot: React.ReactNode;
}) => {
  const {
    control,
    index
  } = useQuizControl();
  const {
    handleCopy,
    handleDelete
  } = useQuizList();
  const {
    t
  } = useTranslation(['common', 'build']);
  const matchPairs = useMatchPairs({
    control,
    index
  });
  return <Fragment>
      <div className="flex flex-row justify-between" onClick={e => e.stopPropagation()}>
        {leftSlot}
        <div className="flex flex-row items-center gap-xs">
          <EditTools.QuizDuplicateButton />
          <EditTools.QuizDeleteButton />
          <EditTools.EditToolsDrawer tools={[{
          icon: <SquareStackIcon size="md" fill={ICON_COLOR.default} />,
          label: t('global.duplicate.button'),
          onClick: () => handleCopy(index)
        }, {
          icon: <TrashIcon size="md" fill={ICON_COLOR.default} />,
          label: t('global.delete'),
          onClick: () => {
            void handleDelete(index);
          }
        }]} />
        </div>
      </div>

      <div className="flex flex-col justify-between gap-xs" onClick={e => e.stopPropagation()}>
        <EditableMatch {...matchPairs} />
        <EditableHint />
      </div>
    </Fragment>;
});